import { render } from "./Appartments.vue?vue&type=template&id=6f7f76e4&scoped=true"
import script from "./Appartments.vue?vue&type=script&lang=js"
export * from "./Appartments.vue?vue&type=script&lang=js"

import "./Appartments.vue?vue&type=style&index=0&id=6f7f76e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7f76e4"]])

export default __exports__